import React, { useEffect, useMemo, useState } from "react";
import "./unpublished-plan-objective-accordion.scss";
import { UnpublishedPlanDraggableAndDroppable } from "./DraggableAndDroppable/UnpublishedPlanDraggableAndDroppable";
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { useDispatch } from "react-redux";
import { NormalText, PrimaryNormalText } from "../../../../../utils/typographyUtils";

export const UnpublishedPlanObjectiveAccordion = ({
  businessPlanId,
  expandedKeyResult,
  callBack,
  expandedObjective,
  objectives,
  closeAllAccordions,
  showActions,
}) => {
  console.log("showActions", showActions);
  const dispatch = useDispatch();
  const [expandedItems, setExpandedItems] = useState([0]);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showConfirmationButtons, setShowConfirmationButtons] = useState({
    show: false,
    type: "",
  });
  const [showRemovePracticePopup, setShowRemovePracticePopup] = useState({
    show: false,
    id: "",
  });
  const memoizedItems = useMemo(() => objectives, [objectives]);
  const [items, setItems] = useState(memoizedItems);

  useEffect(() => {
    setItems(objectives);
  }, [objectives]);

  useEffect(() => {
    if (closeAllAccordions) {
      setExpandedItems([0]);
    }
  }, [closeAllAccordions]);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor),
  );

  const handleAccordionToggle = (index) => {
    setExpandedItems((prevExpandedItems) => {
      if (prevExpandedItems.includes(index)) {
        return prevExpandedItems.filter((item) => item !== index);
      } else {
        return [...prevExpandedItems, index];
      }
    });
  };

  if (!items.length) {
    return (
      <NormalText classNames={"text-center my-4"}>
        No Objectives found. Click on{" "}
        <PrimaryNormalText>"Add X-Ray Recommendation"</PrimaryNormalText> button
        to add new objective(s)
      </NormalText>
    );
  }
  return (
    <div className="px-3 pt-2" id="unpublished-plan-objective-accordion">
      {items.map((objective, index) => {
        return (
          <UnpublishedPlanDraggableAndDroppable
            key={objective.businessPlanObjectiveId}
            callBack={callBack}
            businessPlanId={businessPlanId}
            isLastObjective={items.length === 1}
            showRemovePracticePopup={showRemovePracticePopup}
            setShowRemovePracticePopup={setShowRemovePracticePopup}
            showConfirmationButtons={showConfirmationButtons}
            setShowConfirmationButtons={setShowConfirmationButtons}
            index={index}
            id={objective.businessPlanObjectiveId}
            objective={objective}
            isExpanded={expandedItems.includes(index)}
            onHeaderClick={() => {
              handleAccordionToggle(index);
            }}
            closeAllAccordions={closeAllAccordions}
            showActions={showActions}
          />
        );
      })}
    </div>
  );
};
